import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTamanLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 135,
	height: 24,
	viewBox: "0 0 90 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.96317 1.51245H0V0H11.7011V1.51245H6.74133L2.858 16H1.07984L4.96317 1.51245ZM19.3008 0H18.3436H17.291H16.5654L12.2801 16H14.0583L17.9382 1.51245H18.7489L22.6323 16H24.4104L20.1217 0H19.3008ZM46.1197 0H47.3289H47.8978L52.1831 16H50.4049L46.525 1.51245H45.7143L41.831 16H41.2008H40.0528H38.7822H38.2747L34.3947 1.51245H33.584L29.7007 16H27.9259L32.2112 0H32.9368H33.9894H35.3553H35.7675L39.6509 14.4875H40.4582L44.3415 0H44.9104H46.1197ZM62.9236 0H61.762H60.5084H59.9872L55.6985 16H57.4767L61.36 1.51245H62.1673L66.0507 16H67.8288L63.5401 0H62.9236ZM87.5828 0L83.6995 14.4875H82.8921L79.0088 0H78.5966H77.2306H76.1781H75.4525L71.1638 16H72.9419L76.8253 1.51245H77.636L81.5159 16H82.0235H83.2941H84.4421H85.0722L89.3609 0H87.5828Z",
		fill: "white"
	})
});
export default SvgTamanLogo;
